// authContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import AuthUtils from '../auth/auth_utils';
import { useUser } from './user_context';

const AuthContext = createContext({ 
  token: null, 
  isAuthReady: false, 
  setToken: () => {},
  logout: () => {}
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(AuthUtils.GetAuthToken());
  const [isAuthReady, setIsAuthReady] = useState(!!token);
  const { clearUser } = useUser();

  // Optionally, if token may be updated elsewhere, subscribe in an effect:
  useEffect(() => {
    if (token) {
      setIsAuthReady(true);
    }
  }, [token]);

  const logout = () => {
    AuthUtils.ClearAuthToken();
    setToken(null);
    setIsAuthReady(false);
    clearUser(); // Clear user data on logout
  };

  return (
    <AuthContext.Provider value={{ token, isAuthReady, setToken, setIsAuthReady, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
